/**
 * The platform's one "edit this card" control: an icon-only pen, placed last
 * in a card header (after any other actions and the "..." menu).
 *
 * Every editable card uses this so the affordance looks and sits the same on
 * every screen - claims, registrations, customers. Editing is the most common
 * card action, so it stays visible rather than inside the "..." menu, which is
 * kept for the less frequent actions. The label is carried for screen readers
 * and as a hover tooltip.
 */

import { Pencil } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/shared/components/ui/button";

export function EditIconButton({
  onClick,
  testId,
  label,
}: {
  onClick: () => void;
  testId?: string;
  /** Accessible name / tooltip. Defaults to "Edit". */
  label?: string;
}) {
  const { t } = useTranslation();
  const name = label ?? t("common.edit", "Edit");
  return (
    <Button
      variant="ghost"
      size="icon-xs"
      data-testid={testId}
      aria-label={name}
      title={name}
      onClick={onClick}
      className="text-[var(--ink-3)] hover:text-[var(--ink)]"
    >
      <Pencil className="h-3.5 w-3.5" />
    </Button>
  );
}
